import { useTranslation } from 'react-i18next';
import { Button } from 'reactstrap';

export interface ReopenDialogProps {
  isOpen: boolean;
  pickListExternalId: string;
  isPending: boolean;
  onSubmit: () => void;
  onCancel: () => void;
}

export function ReopenDialog({ isOpen, pickListExternalId, isPending, onSubmit, onCancel }: ReopenDialogProps) {
  const { t } = useTranslation('picklist');
  if (!isOpen) return null;
  const canSubmit = !isPending;
  return (
    <div role="dialog" aria-modal="true" aria-label={t('reopen_dialog.aria_label', { label: pickListExternalId })}
         style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}
         onClick={onCancel}>
      <div onClick={(e) => e.stopPropagation()}
           style={{ background: 'var(--vp-bg)', padding: 16, borderRadius: 'var(--vp-r-md)',
                    minWidth: 420, maxWidth: 560, boxShadow: 'var(--vp-shadow-lg)' }}>
        <h5 className="fs-15 mb-2">{t('reopen_dialog.title_q', { label: pickListExternalId })}</h5>
        <p className="small text-muted mb-3">
          {t('reopen_dialog.warning_intro')} <strong>{t('reopen_dialog.warning_state')}</strong>{t('reopen_dialog.warning_outro')}
        </p>
        <div className="d-flex gap-2 justify-content-end mt-3">
          <Button type="button" color="light" onClick={onCancel}>{t('reopen_dialog.cancel')}</Button>
          <Button type="button" color="primary" disabled={!canSubmit} onClick={() => onSubmit()}>
            {isPending ? t('reopen_dialog.submitting') : t('reopen_dialog.submit')}
          </Button>
        </div>
      </div>
    </div>
  );
}
